import AddLocationOnProposal from './AddLocationOnProposal';
export default AddLocationOnProposal;